export default __webpack_public_path__ + "static/media/Combustion Love.8f5cecc6.jpg";